import styled from "styled-components/macro";

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 515px;
  padding: 15px ${({ theme }) => theme.resolve("spacing_none")} 15px;
  margin: 15px ${({ theme }) => theme.resolve("spacing_none")};
  & > * {
    margin-bottom: ${({ theme }) => theme.resolve("spacing_2xl")};
  }
`;

export type FormSource = "existing" | "new";
